import {
    ChartOfAccountsTemplatesView,
    ChartOfAccountsTemplatesViewColumn,
} from "@common/types/views/chartOfAccountsTemplatesView";
import { ViewDensity, ViewType } from "@common/types/views/views";

export const defaultChartOfAccountsTemplatesView: ChartOfAccountsTemplatesView =
    {
        type: ViewType.CHART_OF_ACCOUNTS_TEMPLATES,
        columns: [
            { id: ChartOfAccountsTemplatesViewColumn.NAME },
            { id: ChartOfAccountsTemplatesViewColumn.ENTITY_TYPE },
            { id: ChartOfAccountsTemplatesViewColumn.INDUSTRY },
            { id: ChartOfAccountsTemplatesViewColumn.BASIS },
            { id: ChartOfAccountsTemplatesViewColumn.DESCRIPTION },
            { id: ChartOfAccountsTemplatesViewColumn.ENTITIES },
            {
                id: ChartOfAccountsTemplatesViewColumn.ACTIONS,
                options: { pin: "right" },
            },
        ],
        filters: {},
        options: {
            selection: false,
            bulkActions: false,
            density: ViewDensity.MD,
        },
    };
